import { capfirst, intcomma } from 'journalize';

//Mappy MAP

 mapboxgl.accessToken ='pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';

  const map = new mapboxgl.Map({
    container:"app",
    style: 'mapbox://styles/latimes/cjyjewclq1gw21clph9wzb98x/draft',
    center: [-118.24,34.05],
    zoom: 10,
    scrollZoom: false,
  });
  
   
map.addControl(new mapboxgl.FullscreenControl(), 'top-left');

// zoom nav
  const nav = new mapboxgl.NavigationControl({ showCompass: false }); 
//geocoder 
  const geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    countries: 'us',
    mapboxgl,
    marker: false,
  });

  document.getElementById('geocoder').appendChild(geocoder.onAdd(map));


  //load data source layer
  map.on('load', () => {
    map.addSource('data',{
    type:'vector',
    url:'mapbox://latimes.6yhlehpz'
    });
   
    //add layer
    map.addLayer({
      id:'hover-layer',
      type:'fill',
      source:'data',
      'source-layer':'zctas_money',
      layout: {},
      paint: {
        'fill-color': 'black',
        'fill-outline-color': 'rgba(0,0,0,0)',
        'fill-opacity': ['case',
          ['boolean', ['feature-state', 'hover'], false],
          0.5,
          0,
        ],     
      }
    }) 
  })
  

// some set up things for data pull 
let hoverId = null;
let con = document.getElementById('console');
let box = document.getElementById('box');
let table = document.getElementById ('table');    
let tbody = document.getElementById('tbody');  
let desc = document.getElementById('table-desc')
  
// When the mouse moves
const onMousemove = function(d, id) {
  con.removeAttribute('hidden', '');
  map.getCanvas().style.cursor = 'pointer';
  
   let dict =  {
     'biden': d.biden_total,
     'buttigieg':d.buttigieg_total,
     'harris':  d.harris_total,
     "O'Rourke": d.orourke_total,
     'sanders':d.sanders_total,
     'warren': d.warren_total
  }

  let top_candidate = d.top_candidate_per_cap
  let zip = d.zcta
  
// This function gets money value of top candidate 
  const money = (top) =>{  
    let header = (`d.${top}_total`)
    return eval(header)
   }

// This function filters the dict by eliminating the top candidate, then filtering to only those with over 0 money raised
  const get_rest = () =>{


   // go through the dictionary and reduce 
   let rest_dict = Object.keys(dict).reduce((k,v)=>{
    if (dict[v] > 0)
      k[v] = dict[v]
     return k},{}
   )

   //into array and sort
   let sortable = Object.entries(rest_dict).sort((a,b)=> b[1]-a[1])
   let ordered_dict = {} 

   //put it back into object 
    sortable.forEach((d)=>{
      ordered_dict[d[0]]=d[1]
    })


   let names = Object.keys(ordered_dict)
   let values = Object.values(ordered_dict)  


   return {
    dict: ordered_dict,
    names:names,
    values:values
   }
  };


//different table depending on orientation
  const htable = (r)=>{
            let row1 = tbody.insertRow()
        let row2 = tbody.insertRow()
        for (var i = 0; i <r ; i++){
          row1.insertCell().innerHTML = `${capfirst(get_rest(top_candidate).names[i])}`
          row2.insertCell().innerHTML = `$${intcomma(Math.round(get_rest(top_candidate).values[i]))}`
        }
  }

  const vtable = (r)=>{
    for ( var i = 0; i <r ; i++){
          let row = tbody.insertRow()
          let nameCell = row.insertCell()
          let moneyCell = row.insertCell()
          moneyCell.classList.add('super-text-right')
          nameCell.innerHTML = `${capfirst(get_rest(top_candidate).names[i])}`
          moneyCell.innerHTML = `${i === 0 ? '$' : ''}${intcomma(Math.round(get_rest(top_candidate).values[i]))}`
        }
  }
 

// conditionals for data popup

  if (top_candidate == undefined ){
    box.style.visibility='visible'
    box.innerHTML =  `<p>No data for this area</p>`
    table.style.visibility = 'hidden'
    con.classList.add('no-table')
  // } else if (top_candidate == 'Tie'){
  //   box.innerHTML=`<p>Candidates in ${zip} raised: </p>`
  //   table.style.visibility = 'visible'
  //   con.classList.remove('no-table')
  //   desc.innerHTML =  ``
  //   let restnumber = get_rest(top_candidate).names.length
  //   while (tbody.hasChildNodes()) {
  //       tbody.removeChild(tbody.lastChild);}
  //   window.innerWidth>window.innerHeight ? vtable(restnumber): htable(restnumber)
  }else{
    con.classList.remove('no-table')
    box.style.visibility='visible'
    // Some sort of statement
    box.innerHTML =  `<p><b>${zip}</b></p>`
//     `<p><b style="color:red">${capfirst(top_candidate=='orourke'? "O'Rourke":top_candidate)}</b> raised the most money in 
//     ${zip} for the amount of <b>$${intcomma(Math.round(money(top_candidate)))}</b> </p>
// `
    let restnumber = get_rest().names.length
    //if there are candidates other than top
    if (restnumber > 0){
        //suface headers
        table.style.visibility = 'visible'
        //remove old table
        while (tbody.hasChildNodes()) {
        tbody.removeChild(tbody.lastChild);}

        //create new table based on orientation
        window.innerWidth>window.innerHeight ? vtable(restnumber): htable(restnumber)
      }else{
        table.style.visibility = 'hidden'
        con.classList.add('no-table')
      }
}

  if (hoverId) {
    map.setFeatureState(
      {
        source: 'data',
        sourceLayer: 'zctas_money',
        id: hoverId,
      },
      { hover: false }
    );
  }
 
  hoverId = id
 
  map.setFeatureState(
    {
      source: 'data',
      sourceLayer: 'zctas_money',
      id: hoverId,
    },
    { hover: true }
  );
};

  
const onMouseleave = function() {
  // If there is a feature in the global hover variable, hide it by setting its hover attribute to false.
  if (hoverId) {
    map.setFeatureState(
      {
        source: 'data',
        sourceLayer: 'zctas_money',
        id: hoverId,
      },
      { hover: false }
    );
  }
  // Zero out the hover id variable
  hoverId = null;

  con.setAttribute('hidden', '');
};
  
  
//execute
  map.addControl(new mapboxgl.FullscreenControl());
  map.addControl(nav, 'top-left'); 
  map.on('mousemove', 'hover-layer', (e) => {
    const feature = e.features[0];
    
    const { properties, id } = feature;

    onMousemove(properties, id);
  });
  map.on('mouseleave', 'hover-layer', onMouseleave);


// LEGEND stuff
let cat6 = ['#7570b3','#66a61e','#e6ab02','#e7298a','#1b9e77','#d95f02']
let cat6names = ['Biden','Buttigieg','Harris',"O'Rourke",'Sanders','Warren']
let i = 0
let ii =0;

let fillblock = (el) =>{
    el.style.backgroundColor = cat6[i]
    i++;
}
let tag = (el) =>{
    el.firstElementChild.innerHTML =  cat6names[ii]
    ii++;
}

let l = document.getElementById('legend-wrapper')

let block = l.querySelectorAll('div')

  block.forEach(function(el){
    fillblock(el)
    tag(el)
  })



